import { createSlice } from '@reduxjs/toolkit';

export interface AuthState {
    bearerToken: string | null;
    isRefreshNeeded: boolean;
    hasCheckedToken: boolean;
}

const initialState: AuthState = {
    bearerToken: null,
    isRefreshNeeded: false,
    hasCheckedToken: false,
};

export const authSlice = createSlice({
    name: 'authConfig',
    initialState,
    reducers: {
        setBearerToken: (state, { payload }) => {
            state.bearerToken = payload;
        },
        requestTokenRefresh: (state) => {
            state.isRefreshNeeded = true;
        },
        clearTokenRefreshRequest: (state) => {
            state.isRefreshNeeded = false;
        },
        setHasCheckedToken: (state) => {
            state.hasCheckedToken = true;
        },
    },
    selectors: {
        selectBearerToken: (state: AuthState) => state.bearerToken,
        selectIsRefreshNeeded: (state: AuthState) => state.isRefreshNeeded,
        selectHasCheckedToken: (state: AuthState) => state.hasCheckedToken,
    },
});

export const { setBearerToken, requestTokenRefresh, clearTokenRefreshRequest, setHasCheckedToken } =
    authSlice.actions;

export const { selectBearerToken, selectIsRefreshNeeded, selectHasCheckedToken } =
    authSlice.selectors;

export default authSlice.reducer;
